<script>
    import Button from '../../../reusableitems/learnbutton.svelte';
    // import DesktopButton from '../../../reusableitems/DesktopButton.svelte';
    import DesktopButton3 from '../../../reusableitems/DesktopButton3.svelte';
    let state1 = '';
</script>

<div class="main">
    <div class="sections {state1}">
        <div
            on:mouseenter={() => (state1 = 'gamers-hover')}
            on:mouseleave={() =>
                (state1 = state1 == 'gamers-hover' ? '' : state1)}
            id="gamers"
        >
            <div class=" contents">
                <div class="sidetext">Gamers</div>
                <div class="h1">GAMERS</div>
            </div>
            <div class="img-wrap">
                <img class="game" src="images/section2/healer.png" alt="" />
            </div>
            <div
                role="presentation"
                class="button"
                on:click={() => {
                    location.href = '/gamers';
                }}
            >
                <Button
                    TextColor="white"
                    ColorHover="white"
                    HoverText="black"
                />
            </div>
            <div class="p">
                <div class="text1">
                    Play in an ever changing world in which you aren’t merely a
                    player and also a creator and administrator.
                </div>

                <div class="Lbtn" style="margin-top:50vh; margin-left:-4vh;">
                    <div style="width:28.611vh; height:3.704vh;">
                        <DesktopButton3
                            btnTitle="Join Games Governance Council"
                            backgroundColor="transparent"
                            backgroundColorHover="black"
                            textClrHover="white"
                            numberClr="#FFF000"
                            seatClr="white"
                            state="Games"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div
            on:mouseenter={() => (state1 = 'artists-hover')}
            on:mouseleave={() =>
                (state1 = state1 == 'artists-hover' ? '' : state1)}
            id="artists"
        >
            <div class=" contents">
                <div class="sidetext">Artists & Musicians</div>
                <div class="h1">ARTISTS & <span>MUSICIANS</span></div>
            </div>
            <div
                class="button"
                role="presentation"
                on:click={() => {
                    location.href = '/artist';
                }}
            >
                <Button TextColor="black" ColorHover="black" HoverText="aqua" />
            </div>
            <div class="img-wrap">
                <img class="statue" src="images/section2/statue.png" alt="" />
            </div>
            <div class="p">
                <div class="text1">
                    A future that expands your 2D canvas infinitely into a
                    multidimensional multiverse. And for the first time, the
                    canvas can almost keep up with your imagination.
                </div>
                <div class="text2">
                    Unleash your talent on this canvas to bring entire worlds
                    into existence and make your fantasy real.
                </div>
                <div class="Lbtn" style="margin-top:2vh">
                    <div style="width:28.611vh; height:3.704vh;">
                        <DesktopButton3
                            btnTitle="Join Visual Art Governance Council"
                            backgroundColorHover="black"
                            textClrHover="#00FFFF"
                            numberClr="black"
                            borderClr="black"
                            textClr="black"
                            seatClr="black"
                            state="Artists & Musicians"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div
            on:mouseenter={() => (state1 = 'storytellers-hover')}
            on:mouseleave={() =>
                (state1 = state1 == 'storytellers-hover' ? '' : state1)}
            id="storytellers"
        >
            <div class=" contents">
                <div class="sidetext">Storytellers</div>
                <div class="h1">STORYTELLERS</div>
            </div>
            <div class="assets">
                <img class="book" src="images/section2/flare.png" alt="" />
            </div>
            <div
                role="presentation"
                class="button2"
                style="margin-top: 32.3vh;"
                on:click={() => {
                    location.href = '/story';
                }}
            >
                <Button
                    TextColor="#F7FFC8"
                    ColorHover="#F7FFC8"
                    HoverText="black"
                />
            </div>
            <div class="p2">
                <div class="text1">
                    Turn your words into a living breathing world in the blink
                    of an eye. Write scenes, characters and their dialogs and
                    watch it happen in real time.
                </div>

                <div class="text2">
                    Unleash your imagination and let our technology do the work.
                </div>
                <div class="Lbtn" style="margin-top:5vh">
                    <div style="width:28.611vh; height:3.704vh;">
                        <DesktopButton3
                            btnTitle="Join Storytellers Governance Council"
                            backgroundColorHover="#F7FFC8"
                            textClrHover="black"
                            state="Storyteller"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div
            on:mouseenter={() => (state1 = 'performers-hover')}
            on:mouseleave={() =>
                (state1 = state1 == 'performers-hover' ? '' : state1)}
            id="performers"
        >
            <div class=" contents">
                <div class="sidetext">Performers</div>
                <div class="h1">PERFORMERS</div>
            </div>
            <div class="img-wrap" style="transition-duration:1s;">
                <img
                    class="spread"
                    src="images/section2/performer1.png"
                    alt=""
                />
            </div>
            <div class="p2">
                <div class="text1">
                    Become part of history as we build the future in which you
                    won't have to take multiple shots for a single performance,
                    rather based on a myriad performance captures, your likeness
                    will be digitized, owned and would be perpetually used into
                    any production.
                </div>
                <div class="Lbtn">
                    <div style="width:28.611vh; height:3.704vh;">
                        <DesktopButton3
                            btnTitle="Join Performers Governance Council"
                            borderClr="black"
                            textClr="black"
                            textClrHover="#67EEBB"
                            seatClr="black"
                            numberClr="black"
                            state="Performers"
                        />
                    </div>
                </div>
            </div>
            <div
                role="presentation"
                class="button"
                on:click={() => {
                    location.href = '/performance';
                }}
            >
                <Button
                    TextColor="black"
                    ColorHover="black"
                    HoverText="#67EEBB"
                />
            </div>
        </div>
    </div>
</div>

<style>
    .main {
        position: relative;
        height: 100vh;
        width: 124.444vh;
        background-color: #f4eeec;
    }
    .sections {
        position: absolute;
        font-family: "Orbitron";
        width: 103.148vh;
        height: 76.111vh;
        display: flex;
        align-items: flex-end;
        left: 13.333vh;
        bottom: 0vh;
    }
    .contents {
        height: 57.5vh;
        width: inherit;
        position: absolute;
        bottom: 0vh;
        left: -3vh;
    }

    .sidetext {
        position: absolute;
        font-size: 1.852vh;
        font-weight: 500;
        top: 3.5vh;
        left: 4.5vh;
        transition: 1s;
        writing-mode: vertical-lr;
    }
    .h1 {
        position: absolute;
        z-index: +1;
        left: 7.5vh;
        top: -4vh;
        font-size: 23.148vh;
        font-weight: 900;
        overflow: hidden;
        transition: 1s;
    }
    .h1 span {
        margin-left: 21vh;
    }
    .p,
    .p2 {
        width: 32.333vh;
        height: 11.667vh;
        font-size: 1.396vh;
        font-weight: 400;
        line-height: 1.967vh;
        text-align: left;
        position: absolute;
        display: flex;
        flex-direction: column;
        gap: 2vh;
        top: 30vh;
    }
    .p {
        left: 80vh;
    }
    .p2 {
        left: -50vh;
        opacity: 0;
    }
    .artists-hover .p {
        left: 13vh;
        transition: 1s;
    }
    .performers-hover #performers .p2 {
        left: 25vh;
        z-index: +1;
        opacity: 1;
        transition: 1s;
    }
    .button {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .button2 {
        position: absolute;
        opacity: 0;
        left: 14vh;
        top: 50vh;
    }
    #storytellers {
        position: relative;
        background-color: #d578ff;
        width: 24.815vh;
        height: 76.111vh;
        transition: 1s;
        overflow: hidden;
    }
    .assets {
        position: absolute;
        width: 45.778vh;
        transition: 1s;
        bottom: -3vh;
        left: -9vh;
    }

    .storytellers-hover #gamers .h1,
    .artists-hover #gamers .h1,
    .performers-hover #gamers .h1 {
        transition: 1s;
    }

    #storytellers .assets .book {
        width: 100%;
        filter: brightness(1.6);
        transition: 1s;
    }
    .storytellers-hover #storytellers {
        width: 76.574vh;
        height: 63.148vh;
        transition: 1s;
    }
    .storytellers-hover #storytellers .assets {
        /* left: 16vh;
        bottom: 19vh;
        transform: scale(2.9);*/

        transition: 1s;
        left: -29vh;
        bottom: -11vh;
        width: 134vh;
    }
    .storytellers-hover #storytellers .p2 {
        left: 40vh;
        opacity: 1;
        color: white;
    }
    .storytellers-hover #storytellers .book {
        filter: brightness(1);
        /* bottom: 0vh;*/
        transition: 1s;
    }
    .storytellers-hover #gamers .img-wrap {
        width: 9.5vh;
        height: 14.907vh;
        transition: 1s;
    }
    .storytellers-hover #gamers,
    .artists-hover #gamers,
    .performers-hover #gamers {
        height: 76.111vh;
    }

    .artists-hover #storytellers,
    .gamers-hover #storytellers,
    .performers-hover #storytellers {
        height: 63.148vh;
    }
    .storytellers-hover .img-wrap {
        position: absolute;
        height: 15.556vh;
        width: 13.38vh;
        transition: 1s;
    }
    .storytellers-hover .button2 {
        opacity: 1;
        top: 18.611vh;
        left: 7.593vh;
        transition: 1s;
        transition: 1s;
    }
    .storytellers-hover #storytellers .sidetext {
        left: -31vh;
        opacity: 0;
        transition: 1s;
        font-size: 1.296vh;
    }
    .storytellers-hover #storytellers .h1 {
        position: absolute;
        top: -2vh;
        font-size: 9.259vh;
        top: -2vh;
        left: -2.2vh;
        transition: 1s;
        color: #f7ffc8;
        transition: 1s;
    }
    .storytellers-hover #artists,
    .storytellers-hover #performers,
    .storytellers-hover #gamers {
        width: 7.407vh;
        transition: 1s;
    }

    .storytellers-hover #performers .sidetext,
    .storytellers-hover #artists .sidetext,
    .storytellers-hover #gamers .sidetext {
        font-size: 1.296vh;
    }
    #artists {
        position: relative;
        background-color: #59e7f2;
        width: 24.815vh;
        height: 67.593vh;
        overflow: hidden;
        transition: 1s;
    }
    .artists-hover #artists {
        width: 76.574vh;
        transition: 1s;
    }
    .artists-hover #artists .button {
        left: 60vh;
        top: 4vh;
        opacity: 1;
    }
    #artists .statue {
        width: 100%;
        height: 100%;
    }
    #artists .img-wrap {
        position: absolute;
        height: 33.148vh;
        width: 38.278vh;
        bottom: 0vh;
        left: -2.5vh;
        transition: 1s;
    }
    .artists-hover #performers .img-wrap,
    .gamers-hover #performers .img-wrap,
    .storytellers-hover #performers .img-wrap {
        position: absolute;
        height: 19.63vh;
        width: 7.407vh;
        left: -1vh;
        top: 51vh;
    }

    .artists-hover #artists .img-wrap {
        height: 56vh;
        width: 65vh;
        left: -3.5vh;
        bottom: -4vh;
        transition: 1s;
    }
    .artists-hover #artists .h1 {
        font-size: 9.259vh;
        left: -2vh;
        transition: 1s;
    }
    .artists-hover #artists .sidetext {
        left: -31vh;
        opacity: 0;
        transition: 1s;
        font-size: 1.296vh;
    }
    .artists-hover #artists .p {
        left: 43vh;
        top: 32vh;
        opacity: 1;
    }
    .artists-hover #gamers {
        width: 7.407vh;
        transition: 1s;
    }

    .artists-hover #storytellers {
        width: 7.407vh;
        transition: 1s;
    }
    .artists-hover #performers {
        width: 7.407vh;
        transition: 1s;
    }
    .artists-hover #performers .sidetext,
    .artists-hover #storytellers .sidetext,
    .artists-hover #gamers .sidetext {
        font-size: 1.296vh;
    }
    #gamers {
        position: relative;
        background-color: #817cf9;
        transition: 1s;
        width: 24.815vh;
        height: 63.148vh;
        overflow: hidden;
    }
    #gamers .img-wrap {
        position: absolute;
        height: 38.241vh;
        width: 28.241vh;
        bottom: -1.111vh;
        transition: 1s;
    }
    #gamers .contents {
        top: 3.5vh;
        transition: 1s;
    }

    .performers-hover #gamers .contents,
    .storytellers-hover #gamers .contents,
    .artists-hover #gamers .contents {
        top: 17vh;
        transition: 1s;
    }
    #artists .contents {
        top: 8vh;
    }
    #storytellers .contents {
        top: 7vh;
        transition: 1s;
    }
    .gamers-hover #storytellers .contents,
    .artists-hover #storytellers .contents,
    .performers-hover #storytellers .contents {
        top: 4vh;

        transition: 1s;
    }
    #performers .contents {
        top: 8vh;
        transition: 1s;
    }
    .game {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: 1s;
    }
    .gamers-hover #gamers {
        width: 76.574vh;
        height: 76.111vh;
        transition: 1s;
        overflow: hidden;
    }
    .gamers-hover #storytellers .assets,
    .artists-hover #storytellers .assets,
    .performers-hover #storytellers .assets {
        /* width: 15vh;
        height: 13vh;
        bottom: -3vh;
        left: -3.6vh;*/

        /*  left: -18.6vh;
    
    scale: 0.4;
  bottom: -14vh; */

        width: 16vh;
        bottom: -2vh;
        left: -4vh;
        transition: 1s;
    }

    .gamers-hover #gamers .img-wrap {
        height: 76.111vh;
        width: 57vh;
        left: 0vh;
        bottom: 0vh;
    }
    .gamers-hover #gamers .p {
        left: 48vh;
        top: 4.63vh;
        width: 25.111vh;
        color: white;
        opacity: 1;
    }
    .gamers-hover #gamers .h1 {
        font-size: 23.148vh;
        top: 32vh;
        font-weight: 900;
        color: white;
        left: -25.4vh;
        transition: 1s;
    }
    .gamers-hover #gamers .sidetext {
        left: -103vh;
        opacity: 0;
        transition: 1s;
        font-size: 1.296vh;
    }
    .gamers-hover #gamers .button {
        opacity: 1;
        top: 14vh;
        left: 63vh;
    }
    .gamers-hover #storytellers {
        width: 7.407vh;
        transition: 1s;
    }
    .gamers-hover #artists {
        width: 7.407vh;
        transition: 1s;
    }
    .gamers-hover #performers {
        width: 7.407vh;
        transition: 1s;
    }
    .gamers-hover #artists .sidetext,
    .gamers-hover #storytellers .sidetext,
    .gamers-hover #performers .sidetext {
        font-size: 1.296vh;
    }
    .gamers-hover #storytellers .contents {
        top: 4vh;
    }
    .performers-hover #storytellers .contents {
        top: 4vh;
    }
    #performers {
        position: relative;
        background-color: #67eebb;
        width: 24.815vh;
        height: 67.037vh;
        transition: 1s;
        overflow: hidden;
    }
    #performers .img-wrap {
        position: absolute;
        height: 54.167vh;
        width: 47.87vh;
        left: -5vh;
        top: 26vh;
    }
    #performers .spread {
        height: 100%;
    }
    .performers-hover #performers {
        width: 76.574vh;
        transition: 1s;
    }
    .performers-hover #performers .h1 {
        font-size: 13.889vh;
        top: -6vh;
        left: -13.333vh;
        transition: 1s;
    }
    .performers-hover #performers .img-wrap {
        position: absolute;
        height: 63vh;
        left: 0vh;
        top: 3.426vh;
    }
    .performers-hover #gamers .img-wrap {
        width: 9.5vh;
        height: 14.907vh;
        transition: 1s;
    }
    .artists-hover #gamers .img-wrap {
        width: 9.5vh;
        height: 14.907vh;
        transition: 1s;
    }
    .performers-hover #artists .img-wrap,
    .gamers-hover #artists .img-wrap,
    .storytellers-hover #artists .img-wrap {
        position: absolute;
        height: 13vh;
        width: 15vh;
        transition: 1s;
    }
    .performers-hover #performers .sidetext {
        left: -21vh;
        transition: 1s;
        font-size: 1.296vh;
    }
    .performers-hover #artists .sidetext,
    .performers-hover #storytellers .sidetext,
    .performers-hover #gamers .sidetext {
        font-size: 1.296vh;
    }
    .performers-hover #gamers {
        width: 7.407vh;
        transition: 1s;
    }

    .performers-hover #artists {
        width: 7.407vh;
        transition: 1s;
    }
    #storytellers .p2,
    #artists .p,
    #gamers .p,
    #performers .p2 {
        position: relative;
        opacity: 0;
        left: 23vh;
    }
    #performers .p2{
        width: 27.5vh;
    }
    .performers-hover #performers .p2 {
        position: absolute;
        height: 14.815vh;
        width: 27.5vh;
        top: 22.037vh;
        left: 45.093vh;
    }
    .performers-hover #performers .button {
        top: 40vh;
        left: 63vh;
        opacity: 1;
    }
    .performers-hover #performers .Lbtn {
        position: relative;
        top: 15.5vh;
        left: -3vh;
    }
    .performers-hover #storytellers {
        width: 7.407vh;
        transition: 1s;
    }
</style>
